'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" {...props}><g fill="currentColor" fillRule="evenodd" clipRule="evenodd"><path d="M4 18.917v7.75h16.893L9.514 15.289a1.333 1.333 0 0 0-1.886 0zm20.664 7.75H28v-3.448l-3.057-3.057a1.333 1.333 0 0 0-1.886 0l-2.449 2.449zm-5.942-5.942L11.4 13.403a4 4 0 0 0-5.657 0L4 15.146V5.333h24v14.115l-1.171-1.172a4 4 0 0 0-5.657 0zM4 2.667a2.667 2.667 0 0 0-2.666 2.666v21.334A2.667 2.667 0 0 0 4 29.333h24a2.667 2.667 0 0 0 2.667-2.666V5.333A2.667 2.667 0 0 0 28 2.667z" /><path d="M22.667 12a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667m0 2.667a4 4 0 1 0 0-8 4 4 0 0 0 0 8" /></g></svg>;
const IconThumbnail = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconThumbnail;